"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchRoutingKey = void 0;
var SearchRoutingKey;
(function (SearchRoutingKey) {
    SearchRoutingKey["SyncChannelPaged"] = "search_SyncChannelPaged";
    SearchRoutingKey["SyncClinicPetPaged"] = "search_SyncClinicPetPaged";
    SearchRoutingKey["SyncClinicPetParentPaged"] = "search_SyncClinicPetParentPaged";
})(SearchRoutingKey = exports.SearchRoutingKey || (exports.SearchRoutingKey = {}));
//# sourceMappingURL=types.js.map